var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 185,
    viewBox: "0 0 185 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -25,
    y: -25,
    width: 235,
    height: 235
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(20px)",
      clipPath: "url(#bgblur_0_5637_12351_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5637_12351)",
    "data-figma-bg-blur-radius": 40
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155 92.5C155 127.018 127.018 155 92.5 155C57.9822 155 30 127.018 30 92.5C30 57.9822 57.9822 30 92.5 30C127.018 30 155 57.9822 155 92.5Z",
    fill: "#397367",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5 22.5C131.16 22.5 162.5 53.8401 162.5 92.5C162.5 131.16 131.16 162.5 92.5 162.5C53.8401 162.5 22.5 131.16 22.5 92.5C22.5 53.8401 53.8401 22.5 92.5 22.5Z",
    stroke: "#397367",
    strokeWidth: 15,
    strokeLinecap: "round",
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.69 73.5604C119.52 75.391 119.52 78.359 117.69 80.1896L86.4396 111.44C84.609 113.27 81.641 113.27 79.8104 111.44L67.3104 98.9396C65.4799 97.109 65.4799 94.141 67.3104 92.3104C69.141 90.4799 72.109 90.4799 73.9396 92.3104L83.125 101.496L97.0927 87.5282L111.06 73.5604C112.891 71.7299 115.859 71.7299 117.69 73.5604Z",
    fill: "#397367"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5637_12351",
    x: -25,
    y: -25,
    width: 235,
    height: 235,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.223529 0 0 0 0 0.45098 0 0 0 0 0.403922 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5637_12351"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5637_12351",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_5637_12351_clip_path",
    transform: "translate(25 25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155 92.5C155 127.018 127.018 155 92.5 155C57.9822 155 30 127.018 30 92.5C30 57.9822 57.9822 30 92.5 30C127.018 30 155 57.9822 155 92.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCircle);
export default __webpack_public_path__ + "static/media/SuccessCircle.e135870c66c506d3fa257c92aae6ccb8.svg";
export { ForwardRef as ReactComponent };